import _ from 'lodash';
import { IntlShape, useIntl } from 'react-intl';
import { getCountryCallingCode } from 'react-phone-number-input';

export const countryCodeList = [
  {
    code: 'AF',
    textEN: 'Afghanistan',
    textTC: '阿富汗',
    textSC: '阿富汗',
    textJP: 'アフガニスタン',
    textKR: '아프가니스탄',
  },
  {
    code: 'AL',
    textEN: 'Albania',
    textTC: '阿爾巴尼亞',
    textSC: '阿尔巴尼亚',
    textJP: 'アルバニア',
    textKR: '알바니아',
  },
  {
    code: 'DZ',
    textEN: 'Algeria',
    textTC: '阿爾及利亞',
    textSC: '阿尔及利亚',
    textJP: 'アルジェリア',
    textKR: '알제리',
  },
  {
    code: 'AS',
    textEN: 'American Samoa',
    textTC: '美屬薩摩亞',
    textSC: '美属萨摩亚',
    textJP: 'アメリカンサモア',
    textKR: '아메리칸사모아',
  },
  {
    code: 'AD',
    textEN: 'Andorra',
    textTC: '安道爾',
    textSC: '安道尔',
    textJP: 'アンドラ',
    textKR: '안도라',
  },
  {
    code: 'AO',
    textEN: 'Angola',
    textTC: '安哥拉',
    textSC: '安哥拉',
    textJP: 'アンゴラ',
    textKR: '앙골라',
  },
  {
    code: 'AI',
    textEN: 'Anguilla',
    textTC: '安圭拉',
    textSC: '安圭拉',
    textJP: 'アンギラ',
    textKR: '앵귈라',
  },
  {
    code: 'AG',
    textEN: 'Antigua And Barbuda',
    textTC: '安提瓜及巴布達',
    textSC: '安提瓜及巴布达',
    textJP: 'アンティグア・バーブーダ',
    textKR: '앤티가 바부다',
  },
  {
    code: 'AR',
    textEN: 'Argentina',
    textTC: '阿根廷',
    textSC: '阿根廷',
    textJP: 'アルゼンチン',
    textKR: '아르헨티나',
  },
  {
    code: 'AM',
    textEN: 'Armenia',
    textTC: '亞美尼亞',
    textSC: '亚美尼亚',
    textJP: 'アルメニア',
    textKR: '아르메니아',
  },
  {
    code: 'AW',
    textEN: 'Aruba',
    textTC: '阿魯巴島',
    textSC: '阿鲁巴岛',
    textJP: 'アルバ',
    textKR: '아루바',
  },
  {
    code: 'AU',
    textEN: 'Australia',
    textTC: '澳大利亞',
    textSC: '澳大利亚',
    textJP: 'オーストラリア',
    textKR: '오스트레일리아',
  },
  {
    code: 'AT',
    textEN: 'Austria',
    textTC: '奧地利',
    textSC: '奥地利',
    textJP: 'オーストリア',
    textKR: '오스트리아',
  },
  {
    code: 'AZ',
    textEN: 'Azerbaijan',
    textTC: '阿塞拜疆',
    textSC: '阿塞拜疆',
    textJP: 'アゼルバイジャン',
    textKR: '아제르바이잔',
  },
  {
    code: 'BH',
    textEN: 'Bahrain',
    textTC: '巴林',
    textSC: '巴林',
    textJP: 'バーレーン',
    textKR: '바레인',
  },
  {
    code: 'BD',
    textEN: 'Bangladesh',
    textTC: '孟加拉國',
    textSC: '孟加拉国',
    textJP: 'バングラデシュ',
    textKR: '방글라데시',
  },
  {
    code: 'BB',
    textEN: 'Barbados',
    textTC: '巴巴多斯',
    textSC: '巴巴多斯',
    textJP: 'バルバドス',
    textKR: '바베이도스',
  },
  {
    code: 'BY',
    textEN: 'Belarus',
    textTC: '白俄羅斯',
    textSC: '白俄罗斯',
    textJP: 'ベラルーシ',
    textKR: '벨라루스',
  },
  {
    code: 'BE',
    textEN: 'Belgium',
    textTC: '比利時',
    textSC: '比利时',
    textJP: 'ベルギー',
    textKR: '벨기에',
  },
  {
    code: 'BZ',
    textEN: 'Belize',
    textTC: '伯利茲',
    textSC: '伯利兹',
    textJP: 'ベリーズ',
    textKR: '벨리즈',
  },
  {
    code: 'BJ',
    textEN: 'Benin',
    textTC: '貝寧',
    textSC: '贝宁',
    textJP: 'ベナン',
    textKR: '베냉',
  },
  {
    code: 'BM',
    textEN: 'Bermuda',
    textTC: '百慕達',
    textSC: '百慕达',
    textJP: 'バミューダ',
    textKR: '버뮤다',
  },
  {
    code: 'BT',
    textEN: 'Bhutan',
    textTC: '不丹',
    textSC: '不丹',
    textJP: 'ブータン',
    textKR: '부탄',
  },
  {
    code: 'BO',
    textEN: 'Bolivia',
    textTC: '玻利維亞',
    textSC: '玻利维亚',
    textJP: 'ボリビア多民族国',
    textKR: '볼리비아 다민족국가',
  },
  {
    code: 'BQ',
    textEN: 'Bonaire, Sint Eustatius and Saba',
    textTC: '荷蘭加勒比區',
    textSC: '荷兰加勒比区',
    textJP: 'ボネール、シント・ユースタティウスおよびサバ',
    textKR: '보네르, 신트 유스타티우스 및 사바',
  },
  {
    code: 'BA',
    textEN: 'Bosnia and Herzegovina',
    textTC: '波斯尼亞和黑塞哥維那',
    textSC: '波斯尼亚和黑塞哥维那',
    textJP: 'ボスニア・ヘルツェゴビナ',
    textKR: '보스니아 헤르체고비나',
  },
  {
    code: 'BW',
    textEN: 'Botswana',
    textTC: '博茨瓦納',
    textSC: '博茨瓦纳',
    textJP: 'ボツワナ',
    textKR: '보츠와나',
  },
  {
    code: 'BV',
    textEN: 'Bouvet Island',
    textTC: '鮑威特島',
    textSC: '布韦岛',
    textJP: 'ブーベ島',
    textKR: '부베 섬',
  },
  {
    code: 'BR',
    textEN: 'Brazil',
    textTC: '巴西',
    textSC: '巴西',
    textJP: 'ブラジル',
    textKR: '브라질',
  },
  {
    code: 'IO',
    textEN: 'British Indian Ocean Territory',
    textTC: '英屬印度洋領地',
    textSC: '英属印度洋领地',
    textJP: 'イギリス領インド洋地域',
    textKR: '영국령 인도양 지역',
  },
  {
    code: 'BN',
    textEN: 'Brunei',
    textTC: '文萊達魯薩蘭國',
    textSC: '文莱达鲁萨兰国',
    textJP: 'ブルネイ・ダルサラーム',
    textKR: '브루나이 다루살람',
  },
  {
    code: 'BG',
    textEN: 'Bulgaria',
    textTC: '保加利亞',
    textSC: '保加利亚',
    textJP: 'ブルガリア',
    textKR: '불가리아',
  },
  {
    code: 'BF',
    textEN: 'Burkina Faso',
    textTC: '布基納法索',
    textSC: '布基纳法索',
    textJP: 'ブルキナファソ',
    textKR: '부르키나파소',
  },
  {
    code: 'BI',
    textEN: 'Burundi',
    textTC: '布隆迪',
    textSC: '布隆迪',
    textJP: 'ブルンジ',
    textKR: '부룬디',
  },
  {
    code: 'KH',
    textEN: 'Cambodia',
    textTC: '柬埔寨',
    textSC: '柬埔寨',
    textJP: 'カンボジア',
    textKR: '캄보디아',
  },
  {
    code: 'CM',
    textEN: 'Cameroon',
    textTC: '喀麥隆',
    textSC: '喀麦隆',
    textJP: 'カメルーン',
    textKR: '캄룬',
  },
  {
    code: 'CA',
    textEN: 'Canada',
    textTC: '加拿大',
    textSC: '加拿大',
    textJP: 'カナダ',
    textKR: '캐나다',
  },
  {
    code: 'CV',
    textEN: 'Cape Verde',
    textTC: '佛得角',
    textSC: '佛得角',
    textJP: 'カーボベルデ',
    textKR: '카보베르데',
  },
  {
    code: 'KY',
    textEN: 'Cayman Islands',
    textTC: '開曼群島',
    textSC: '开曼群岛',
    textJP: 'ケイマン諸島',
    textKR: '케이맨 제도',
  },
  {
    code: 'CF',
    textEN: 'Central African Republic',
    textTC: '中非共和國',
    textSC: '中非共和国',
    textJP: '中央アフリカ共和国',
    textKR: '중앙아프리카 공화국',
  },
  {
    code: 'TD',
    textEN: 'Chad',
    textTC: '乍得',
    textSC: '乍得',
    textJP: 'チャド',
    textKR: '차드',
  },
  {
    code: 'CL',
    textEN: 'Chile',
    textTC: '智利',
    textSC: '智利',
    textJP: 'チリ',
    textKR: '칠레',
  },
  {
    code: 'CN',
    textEN: 'China',
    textTC: '中國',
    textSC: '中国',
    textJP: '中国',
    textKR: '중국',
  },
  {
    code: 'CX',
    textEN: 'Christmas Island',
    textTC: '聖誕島',
    textSC: '圣诞岛',
    textJP: 'クリスマス島',
    textKR: '크리스마스 섬',
  },
  {
    code: 'CC',
    textEN: 'Cocos (Keeling) Islands',
    textTC: '科科斯（基林）群島',
    textSC: '科科斯（基林）群岛',
    textJP: 'ココス（キーリング）諸島',
    textKR: '코코스(키링) 제도',
  },
  {
    code: 'CO',
    textEN: 'Colombia',
    textTC: '哥倫比亞',
    textSC: '哥伦比亚',
    textJP: 'コロンビア',
    textKR: '콜롬비아',
  },
  {
    code: 'KM',
    textEN: 'Comoros',
    textTC: '科摩羅',
    textSC: '科摩罗',
    textJP: 'コモロ',
    textKR: '코모로',
  },
  {
    code: 'CG',
    textEN: 'Congo',
    textTC: '剛果共和國（布）',
    textSC: '刚果共和国（布）',
    textJP: 'コンゴ',
    textKR: '콩고',
  },
  {
    code: 'CK',
    textEN: 'Cook Islands',
    textTC: '庫克群島',
    textSC: '库克群岛',
    textJP: 'クック諸島',
    textKR: '쿡 제도',
  },
  {
    code: 'CR',
    textEN: 'Costa Rica',
    textTC: '哥斯達黎加',
    textSC: '哥斯达黎加',
    textJP: 'コスタリカ',
    textKR: '코스타리카',
  },
  {
    code: 'CI',
    textEN: "Cote D'Ivoire (Ivory Coast)",
    textTC: '科特迪瓦',
    textSC: '科特迪瓦',
    textJP: 'コートジボワール',
    textKR: '코트디부아르',
  },
  {
    code: 'HR',
    textEN: 'Croatia',
    textTC: '克羅地亞',
    textSC: '克罗地亚',
    textJP: 'クロアチア',
    textKR: '크로아티아',
  },
  {
    code: 'CU',
    textEN: 'Cuba',
    textTC: '古巴',
    textSC: '古巴',
    textJP: 'キューバ',
    textKR: '쿠바',
  },
  {
    code: 'CW',
    textEN: 'Curaçao',
    textTC: '庫拉索',
    textSC: '库拉索',
    textJP: 'キュラソー',
    textKR: '쿠라사오',
  },
  {
    code: 'CY',
    textEN: 'Cyprus',
    textTC: '塞浦路斯',
    textSC: '塞浦路斯',
    textJP: 'キプロス',
    textKR: '키프로스',
  },
  {
    code: 'CZ',
    textEN: 'Czech Republic',
    textTC: '捷克共和國',
    textSC: '捷克共和国',
    textJP: 'チェコ',
    textKR: '체코',
  },
  {
    code: 'CD',
    textEN: 'Democratic Republic of the Congo',
    textTC: '剛果民主共和國（金）',
    textSC: '刚果民主共和国（金）',
    textJP: 'コンゴ民主共和国',
    textKR: '콩고 민주 공화국',
  },
  {
    code: 'DK',
    textEN: 'Denmark',
    textTC: '丹麥',
    textSC: '丹麦',
    textJP: 'デンマーク',
    textKR: '덴마크',
  },
  {
    code: 'DJ',
    textEN: 'Djibouti',
    textTC: '吉布提',
    textSC: '吉布提',
    textJP: 'ジブチ',
    textKR: '지부티',
  },
  {
    code: 'DM',
    textEN: 'Dominica',
    textTC: '多米尼克',
    textSC: '多米尼克',
    textJP: 'ドミニカ',
    textKR: '도미니카',
  },
  {
    code: 'DO',
    textEN: 'Dominican Republic',
    textTC: '多米尼加共和國',
    textSC: '多米尼加共和国',
    textJP: 'ドミニカ共和国',
    textKR: '도미니카 공화국',
  },
  {
    code: 'TL',
    textEN: 'East Timor',
    textTC: '東帝汶',
    textSC: '东帝汶',
  },
  {
    code: 'EC',
    textEN: 'Ecuador',
    textTC: '厄瓜多爾',
    textSC: '厄瓜多尔',
    textJP: 'エクアドル',
    textKR: '에콰도르',
  },
  {
    code: 'EG',
    textEN: 'Egypt',
    textTC: '埃及',
    textSC: '埃及',
    textJP: 'エジプト',
    textKR: '이집트',
  },
  {
    code: 'SV',
    textEN: 'El Salvador',
    textTC: '薩爾瓦多',
    textSC: '萨尔瓦多',
    textJP: 'エルサルバドル',
    textKR: '엘살바도르',
  },
  {
    code: 'GQ',
    textEN: 'Equatorial Guinea',
    textTC: '赤道幾內亞',
    textSC: '赤道几内亚',
    textJP: '赤道ギニア',
    textKR: '적도 기니',
  },
  {
    code: 'ER',
    textEN: 'Eritrea',
    textTC: '厄立特里亞',
    textSC: '厄立特里亚',
    textJP: 'エリトリア',
    textKR: '에리트레아',
  },
  {
    code: 'EE',
    textEN: 'Estonia',
    textTC: '愛沙尼亞',
    textSC: '爱沙尼亚',
    textJP: 'エストニア',
    textKR: '에스토니아',
  },
  {
    code: 'ET',
    textEN: 'Ethiopia',
    textTC: '埃塞俄比亞',
    textSC: '埃塞俄比亚',
    textJP: 'エチオピア',
    textKR: '에티오피아',
  },
  {
    code: 'FK',
    textEN: 'Falkland Islands',
    textTC: '福克蘭（馬爾維納斯）群島',
    textSC: '福克兰（马尔维纳斯）群岛',
    textJP: 'フォークランド諸島（マルビナス諸島）',
    textKR: '포클랜드 제도 (말비나스 제도)',
  },
  {
    code: 'FO',
    textEN: 'Faroe Islands',
    textTC: '法羅群島',
    textSC: '法罗群岛',
    textJP: 'フェロー諸島',
    textKR: '페로 제도',
  },
  {
    code: 'FJ',
    textEN: 'Fiji Islands',
    textTC: '斐濟',
    textSC: '斐济',
    textJP: 'フィジー',
    textKR: '피지',
  },
  {
    code: 'FI',
    textEN: 'Finland',
    textTC: '芬蘭',
    textSC: '芬兰',
    textJP: 'フィンランド',
    textKR: '핀란드',
  },
  {
    code: 'FR',
    textEN: 'France',
    textTC: '法國',
    textSC: '法国',
    textJP: 'フランス',
    textKR: '프랑스',
  },
  {
    code: 'GF',
    textEN: 'French Guiana',
    textTC: '法屬圭亞那',
    textSC: '法属圭亚那',
    textJP: '仏領ギアナ',
    textKR: '프랑스 기아나',
  },
  {
    code: 'PF',
    textEN: 'French Polynesia',
    textTC: '法屬波利尼西亞',
    textSC: '法属波利尼西亚',
    textJP: 'フランス領ポリネシア',
    textKR: '프랑스령 폴리네시아',
  },
  {
    code: 'TF',
    textEN: 'French Southern Territories',
    textTC: '法屬南部領地',
    textSC: '法属南部领地',
    textJP: 'フランス領南方・南極地域',
    textKR: '프랑스 남부 및 남극 영토',
  },
  {
    code: 'GA',
    textEN: 'Gabon',
    textTC: '加蓬',
    textSC: '加蓬',
    textJP: 'ガボン',
    textKR: '가봉',
  },
  {
    code: 'GE',
    textEN: 'Georgia',
    textTC: '格魯吉亞',
    textSC: '格鲁吉亚',
    textJP: 'ジョージア',
    textKR: '조지아',
  },
  {
    code: 'DE',
    textEN: 'Germany',
    textTC: '德國',
    textSC: '德国',
    textJP: 'ドイツ',
    textKR: '독일',
  },
  {
    code: 'GH',
    textEN: 'Ghana',
    textTC: '加納',
    textSC: '加纳',
    textJP: 'ガーナ',
    textKR: '가나',
  },
  {
    code: 'GI',
    textEN: 'Gibraltar',
    textTC: '直布羅陀',
    textSC: '直布罗陀',
    textJP: 'ジブラルタル',
    textKR: '지브롤터',
  },
  {
    code: 'GR',
    textEN: 'Greece',
    textTC: '希臘',
    textSC: '希腊',
    textJP: 'ギリシャ',
    textKR: '그리스',
  },
  {
    code: 'GL',
    textEN: 'Greenland',
    textTC: '格陵蘭',
    textSC: '格陵兰',
    textJP: 'グリーンランド',
    textKR: '그린란드',
  },
  {
    code: 'GD',
    textEN: 'Grenada',
    textTC: '格拉納達',
    textSC: '格林纳达',
    textJP: 'グレナダ',
    textKR: '그레나다',
  },
  {
    code: 'GP',
    textEN: 'Guadeloupe',
    textTC: '瓜德羅普',
    textSC: '瓜德罗普',
    textJP: 'グアドループ',
    textKR: '과들루프',
  },
  {
    code: 'GU',
    textEN: 'Guam',
    textTC: '關島',
    textSC: '关岛',
    textJP: 'グアム',
    textKR: '괌',
  },
  {
    code: 'GT',
    textEN: 'Guatemala',
    textTC: '危地馬拉',
    textSC: '危地马拉',
    textJP: 'グアテマラ',
    textKR: '과테말라',
  },
  {
    code: 'GN',
    textEN: 'Guinea',
    textTC: '幾內亞',
    textSC: '几内亚',
    textJP: 'ギニア',
    textKR: '기니',
  },
  {
    code: 'GW',
    textEN: 'Guinea-Bissau',
    textTC: '幾內亞比紹',
    textSC: '几内亚比绍',
    textJP: 'ギニアビサウ',
    textKR: '기니비사우',
  },
  {
    code: 'GY',
    textEN: 'Guyana',
    textTC: '圭亞那',
    textSC: '圭亚那',
    textJP: 'ガイアナ',
    textKR: '가이아나',
  },
  {
    code: 'HT',
    textEN: 'Haiti',
    textTC: '海地',
    textSC: '海地',
    textJP: 'ハイチ',
    textKR: '아이티',
  },
  {
    code: 'HM',
    textEN: 'Heard Island and McDonald Islands',
    textTC: '赫德和麥克唐納群島',
    textSC: '赫德和麦克唐纳群岛',
    textJP: 'ハード島およびマクドナルド諸島',
    textKR: '허드섬 및 맥도날드 제도',
  },
  {
    code: 'HN',
    textEN: 'Honduras',
    textTC: '洪都拉斯',
    textSC: '洪都拉斯',
    textJP: 'ホンジュラス',
    textKR: '온두라스',
  },
  {
    code: 'HK',
    textEN: 'Hong Kong S.A.R.',
    textTC: '香港特別行政區',
    textSC: '香港特別行政區',
    textJP: '香港',
    textKR: '홍콩',
  },
  {
    code: 'HU',
    textEN: 'Hungary',
    textTC: '匈牙利',
    textSC: '匈牙利',
    textJP: 'ハンガリー',
    textKR: '헝가리',
  },
  {
    code: 'IS',
    textEN: 'Iceland',
    textTC: '冰島',
    textSC: '冰岛',
    textJP: 'アイスランド',
    textKR: '아이슬란드',
  },
  {
    code: 'IN',
    textEN: 'India',
    textTC: '印度',
    textSC: '印度',
    textJP: 'インド',
    textKR: '인도',
  },
  {
    code: 'ID',
    textEN: 'Indonesia',
    textTC: '印度尼西亞',
    textSC: '印度尼西亚',
    textJP: 'インドネシア',
    textKR: '인도네시아',
  },
  {
    code: 'IR',
    textEN: 'Iran',
    textTC: '伊朗',
    textSC: '伊朗',
    textJP: 'イラン・イスラム共和国',
    textKR: '이란 이슬람 공화국',
  },
  {
    code: 'IQ',
    textEN: 'Iraq',
    textTC: '伊拉克',
    textSC: '伊拉克',
    textJP: 'イラク',
    textKR: '이라크',
  },
  {
    code: 'IE',
    textEN: 'Ireland',
    textTC: '愛爾蘭',
    textSC: '爱尔兰',
    textJP: 'アイルランド',
    textKR: '아일랜드',
  },
  {
    code: 'IL',
    textEN: 'Israel',
    textTC: '以色列',
    textSC: '以色列',
    textJP: 'イスラエル',
    textKR: '이스라엘',
  },
  {
    code: 'IT',
    textEN: 'Italy',
    textTC: '意大利',
    textSC: '意大利',
    textJP: 'イタリア',
    textKR: '이탈리아',
  },
  {
    code: 'JM',
    textEN: 'Jamaica',
    textTC: '牙買加',
    textSC: '牙买加',
    textJP: 'ジャマイカ',
    textKR: '자메이카',
  },
  {
    code: 'JP',
    textEN: 'Japan',
    textTC: '日本',
    textSC: '日本',
    textJP: '日本',
    textKR: '일본',
  },
  {
    code: 'JO',
    textEN: 'Jordan',
    textTC: '約旦',
    textSC: '约旦',
    textJP: 'ヨルダン',
    textKR: '요르단',
  },
  {
    code: 'KZ',
    textEN: 'Kazakhstan',
    textTC: '哈薩克斯坦',
    textSC: '哈萨克斯坦',
    textJP: 'カザフスタン',
    textKR: '카자흐스탄',
  },
  {
    code: 'KE',
    textEN: 'Kenya',
    textTC: '肯尼亞',
    textSC: '肯尼亚',
    textJP: 'ケニア',
    textKR: '케냐',
  },
  {
    code: 'KI',
    textEN: 'Kiribati',
    textTC: '基里巴斯',
    textSC: '基里巴斯',
    textJP: 'キリバス',
    textKR: '키리바시',
  },
  {
    code: 'KW',
    textEN: 'Kuwait',
    textTC: '科威特',
    textSC: '科威特',
    textJP: 'クウェート',
    textKR: '쿠웨이트',
  },
  {
    code: 'KG',
    textEN: 'Kyrgyzstan',
    textTC: '吉爾吉斯斯坦',
    textSC: '吉尔吉斯斯坦',
    textJP: 'キルギス',
    textKR: '키르기스스탄',
  },
  {
    code: 'LA',
    textEN: 'Laos',
    textTC: '老撾',
    textSC: '老挝',
    textJP: 'ラオス人民民主共和国',
    textKR: '라오스인민민주공화국',
  },
  {
    code: 'LV',
    textEN: 'Latvia',
    textTC: '拉脫維亞',
    textSC: '拉脱维亚',
    textJP: 'ラトビア',
    textKR: '라트비아',
  },
  {
    code: 'LB',
    textEN: 'Lebanon',
    textTC: '黎巴嫩',
    textSC: '黎巴嫩',
    textJP: 'レバノン',
    textKR: '레바논',
  },
  {
    code: 'LS',
    textEN: 'Lesotho',
    textTC: '萊索托',
    textSC: '莱索托',
    textJP: 'レソト',
    textKR: '레소토',
  },
  {
    code: 'LR',
    textEN: 'Liberia',
    textTC: '利比里亞',
    textSC: '利比里亚',
    textJP: 'リベリア',
    textKR: '라이베리아',
  },
  {
    code: 'LY',
    textEN: 'Libya',
    textTC: '利比亞',
    textSC: '利比亚',
    textJP: 'リビア',
    textKR: '리비아',
  },
  {
    code: 'LI',
    textEN: 'Liechtenstein',
    textTC: '列支敦士登',
    textSC: '列支敦士登',
    textJP: 'リヒテンシュタイン',
    textKR: '리히텐슈타인',
  },
  {
    code: 'LT',
    textEN: 'Lithuania',
    textTC: '立陶宛',
    textSC: '立陶宛',
    textJP: 'リトアニア',
    textKR: '리투아니아',
  },
  {
    code: 'LU',
    textEN: 'Luxembourg',
    textTC: '盧森堡',
    textSC: '卢森堡',
    textJP: 'ルクセンブルク',
    textKR: '룩셈부르크',
  },
  {
    code: 'MO',
    textEN: 'Macau S.A.R.',
    textTC: '澳門特別行政區',
    textSC: '澳门特別行政區',
    textJP: 'マカオ',
    textKR: '마카오',
  },
  {
    code: 'MK',
    textEN: 'Macedonia',
    textTC: '馬其頓',
    textSC: '马其顿',
    textJP: 'マケドニア旧ユーゴスラビア共和国',
    textKR: '마케도니아 과거 유고슬라비아 공화국',
  },
  {
    code: 'MG',
    textEN: 'Madagascar',
    textTC: '馬達加斯加',
    textSC: '马达加斯加',
    textJP: 'マダガスカル',
    textKR: '마다가스카르',
  },
  {
    code: 'MW',
    textEN: 'Malawi',
    textTC: '馬拉維',
    textSC: '马拉维',
    textJP: 'マラウイ',
    textKR: '말라위',
  },
  {
    code: 'MY',
    textEN: 'Malaysia',
    textTC: '馬來西亞',
    textSC: '马来西亚',
    textJP: 'マレーシア',
    textKR: '말레이시아',
  },
  {
    code: 'MV',
    textEN: 'Maldives',
    textTC: '馬爾代夫',
    textSC: '马尔代夫',
    textJP: 'モルディブ',
    textKR: '몰디브',
  },
  {
    code: 'ML',
    textEN: 'Mali',
    textTC: '馬里',
    textSC: '马里',
    textJP: 'マリ',
    textKR: '말리',
  },
  {
    code: 'MT',
    textEN: 'Malta',
    textTC: '馬耳他',
    textSC: '马耳他',
    textJP: 'マルタ',
    textKR: '몰타',
  },
  {
    code: 'IM',
    textEN: 'Man (Isle of)',
    textTC: '馬恩島',
    textSC: '马恩岛',
    textJP: 'マン島',
    textKR: '맨섬',
  },
  {
    code: 'MH',
    textEN: 'Marshall Islands',
    textTC: '馬紹爾群島',
    textSC: '马绍尔群岛',
    textJP: 'マーシャル諸島',
    textKR: '마셜 제도',
  },
  {
    code: 'MQ',
    textEN: 'Martinique',
    textTC: '馬提尼克島',
    textSC: '马提尼克岛',
    textJP: 'マルティニーク',
    textKR: '마르티니크',
  },
  {
    code: 'MR',
    textEN: 'Mauritania',
    textTC: '毛里塔尼亞',
    textSC: '毛里塔尼亚',
    textJP: 'モーリタニア',
    textKR: '모리타니아',
  },
  {
    code: 'MU',
    textEN: 'Mauritius',
    textTC: '毛里求斯',
    textSC: '毛里求斯',
    textJP: 'モーリシャス',
    textKR: '모리셔스',
  },
  {
    code: 'YT',
    textEN: 'Mayotte',
    textTC: '馬約特',
    textSC: '马约特',
    textJP: 'マヨット',
    textKR: '마요트',
  },
  {
    code: 'MX',
    textEN: 'Mexico',
    textTC: '墨西哥',
    textSC: '墨西哥',
    textJP: 'メキシコ',
    textKR: '멕시코',
  },
  {
    code: 'FM',
    textEN: 'Micronesia',
    textTC: '密克羅尼西亞聯邦',
    textSC: '密克罗尼西亚联邦',
    textJP: 'ミクロネシア連邦',
    textKR: '미크로네시아 연방',
  },
  {
    code: 'MD',
    textEN: 'Moldova',
    textTC: '摩爾多瓦',
    textSC: '摩尔多瓦',
    textJP: 'モルドバ共和国',
    textKR: '몰도바 공화국',
  },
  {
    code: 'MC',
    textEN: 'Monaco',
    textTC: '摩納哥',
    textSC: '摩纳哥',
    textJP: 'モナコ',
    textKR: '모나코',
  },
  {
    code: 'MN',
    textEN: 'Mongolia',
    textTC: '蒙古',
    textSC: '蒙古',
    textJP: 'モンゴル',
    textKR: '몽골',
  },
  {
    code: 'ME',
    textEN: 'Montenegro',
    textTC: '黑山共和國',
    textSC: '黑山共和国',
    textJP: 'モンテネグロ',
    textKR: '몬테네그로',
  },
  {
    code: 'MS',
    textEN: 'Montserrat',
    textTC: '蒙塞拉特',
    textSC: '蒙塞拉特',
    textJP: 'モントセラト',
    textKR: '몬세라트',
  },
  {
    code: 'MA',
    textEN: 'Morocco',
    textTC: '摩洛哥',
    textSC: '摩洛哥',
    textJP: 'モロッコ',
    textKR: '모로코',
  },
  {
    code: 'MZ',
    textEN: 'Mozambique',
    textTC: '莫桑比克',
    textSC: '莫桑比克',
    textJP: 'モザンビーク',
    textKR: '모잠비크',
  },
  {
    code: 'MM',
    textEN: 'Myanmar',
    textTC: '緬甸',
    textSC: '缅甸',
    textJP: 'ミャンマー',
    textKR: '미얀마',
  },
  {
    code: 'NA',
    textEN: 'Namibia',
    textTC: '納米比亞',
    textSC: '纳米比亚',
    textJP: 'ナミビア',
    textKR: '나미비아',
  },
  {
    code: 'NR',
    textEN: 'Nauru',
    textTC: '瑙魯',
    textSC: '瑙鲁',
    textJP: 'ナウル',
    textKR: '나우루',
  },
  {
    code: 'NP',
    textEN: 'Nepal',
    textTC: '尼泊爾',
    textSC: '尼泊尔',
    textJP: 'ネパール',
    textKR: '네팔',
  },
  {
    code: 'NL',
    textEN: 'Netherlands',
    textTC: '荷蘭',
    textSC: '荷兰',
    textJP: 'オランダ',
    textKR: '네덜란드',
  },
  {
    code: 'NC',
    textEN: 'New Caledonia',
    textTC: '新喀里多尼亚',
    textSC: '新喀里多尼亚',
    textJP: 'ニューカレドニア',
    textKR: '누벨칼레도니',
  },
  {
    code: 'NZ',
    textEN: 'New Zealand',
    textTC: '新西蘭',
    textSC: '新西兰',
    textJP: 'ニュージーランド',
    textKR: '뉴질랜드',
  },
  {
    code: 'NI',
    textEN: 'Nicaragua',
    textTC: '尼加拉瓜',
    textSC: '尼加拉瓜',
    textJP: 'ニカラグア',
    textKR: '니카라과',
  },
  {
    code: 'NE',
    textEN: 'Niger',
    textTC: '尼日爾',
    textSC: '尼日尔',
    textJP: 'ニジェール',
    textKR: '니제르',
  },
  {
    code: 'NG',
    textEN: 'Nigeria',
    textTC: '尼日利亞',
    textSC: '尼日利亚',
    textJP: 'ナイジェリア',
    textKR: '나이지리아',
  },
  {
    code: 'NU',
    textEN: 'Niue',
    textTC: '紐埃',
    textSC: '纽埃',
    textJP: 'ニウエ',
    textKR: '니우에',
  },
  {
    code: 'NF',
    textEN: 'Norfolk Island',
    textTC: '諾福克島',
    textSC: '诺福克岛',
    textJP: 'ノーフォーク島',
    textKR: '노퍽 섬',
  },
  {
    code: 'KP',
    textEN: 'North Korea',
    textTC: '朝鮮民族主義人民共和國（北韓）',
    textSC: '朝鲜民主主义人民共和国（北韩）',
    textJP: '朝鮮民主主義人民共和国',
    textKR: '조선민주주의인민공화국',
  },
  {
    code: 'MP',
    textEN: 'Northern Mariana Islands',
    textTC: '北馬里亞納群島',
    textSC: '北马里亚纳群岛',
    textJP: '北マリアナ諸島',
    textKR: '북마리아나 제도',
  },
  {
    code: 'NO',
    textEN: 'Norway',
    textTC: '挪威',
    textSC: '挪威',
    textJP: 'ノルウェー',
    textKR: '노르웨이',
  },
  {
    code: 'OM',
    textEN: 'Oman',
    textTC: '阿曼',
    textSC: '阿曼',
    textJP: 'オマーン',
    textKR: '오만',
  },
  {
    code: 'PK',
    textEN: 'Pakistan',
    textTC: '巴基斯坦',
    textSC: '巴基斯坦',
    textJP: 'パキスタン',
    textKR: '파키스탄',
  },
  {
    code: 'PW',
    textEN: 'Palau',
    textTC: '帕勞',
    textSC: '帕劳',
    textJP: 'パラオ',
    textKR: '팔라우',
  },
  {
    code: 'PA',
    textEN: 'Panama',
    textTC: '巴拿馬',
    textSC: '巴拿马',
    textJP: 'パナマ',
    textKR: '파나마',
  },
  {
    code: 'PG',
    textEN: 'Papua new Guinea',
    textTC: '巴布亞新幾內亞',
    textSC: '巴布亚新几内亚',
    textJP: 'パプアニューギニア',
    textKR: '파푸아뉴기니',
  },
  {
    code: 'PY',
    textEN: 'Paraguay',
    textTC: '巴拉圭',
    textSC: '巴拉圭',
    textJP: 'パラグアイ',
    textKR: '파라과이',
  },
  {
    code: 'PE',
    textEN: 'Peru',
    textTC: '秘魯',
    textSC: '秘鲁',
    textJP: 'ペルー',
    textKR: '페루',
  },
  {
    code: 'PH',
    textEN: 'Philippines',
    textTC: '菲律賓',
    textSC: '菲律宾',
    textJP: 'フィリピン',
    textKR: '필리핀',
  },
  {
    code: 'PN',
    textEN: 'Pitcairn Island',
    textTC: '皮特肯',
    textSC: '皮特肯',
    textJP: 'ピトケアン',
    textKR: '핏케언',
  },
  {
    code: 'PL',
    textEN: 'Poland',
    textTC: '波蘭',
    textSC: '波兰',
    textJP: 'ポーランド',
    textKR: '폴란드',
  },
  {
    code: 'PT',
    textEN: 'Portugal',
    textTC: '葡萄牙',
    textSC: '葡萄牙',
    textJP: 'ポルトガル',
    textKR: '포르투갈',
  },
  {
    code: 'PR',
    textEN: 'Puerto Rico',
    textTC: '波多黎各',
    textSC: '波多黎各',
    textJP: 'プエルトリコ',
    textKR: '푸에르토리코',
  },
  {
    code: 'QA',
    textEN: 'Qatar',
    textTC: '卡塔爾',
    textSC: '卡塔尔',
    textJP: 'カタール',
    textKR: '카타르',
  },
  {
    code: 'RE',
    textEN: 'Reunion',
    textTC: '留尼旺',
    textSC: '留尼旺',
    textJP: 'レユニオン',
    textKR: '레위니옹',
  },
  {
    code: 'RO',
    textEN: 'Romania',
    textTC: '羅馬尼亞',
    textSC: '罗马尼亚',
    textJP: 'ルーマニア',
    textKR: '루마니아',
  },
  {
    code: 'RU',
    textEN: 'Russia',
    textTC: '俄羅斯',
    textSC: '俄罗斯',
    textJP: 'ロシア連邦',
    textKR: '러시아 연방',
  },
  {
    code: 'RW',
    textEN: 'Rwanda',
    textTC: '盧旺達',
    textSC: '卢旺达',
    textJP: 'ルワンダ',
    textKR: '르완다',
  },
  {
    code: 'SH',
    textEN: 'Saint Helena',
    textTC: '聖赫勒拿島',
    textSC: '圣赫勒拿岛',
    textJP: 'セントヘレナ・アセンションおよびトリスタンダクーニャ',
    textKR: '세인트헬레나, 애센션 및 트리스탄 다 쿠냐',
  },
  {
    code: 'KN',
    textEN: 'Saint Kitts And Nevis',
    textTC: '聖基茨和尼維斯',
    textSC: '圣基茨和尼维斯',
    textJP: 'セントクリストファー・ネイビス',
    textKR: '세인트키츠 네비스',
  },
  {
    code: 'LC',
    textEN: 'Saint Lucia',
    textTC: '聖盧西亞',
    textSC: '圣卢西亚',
    textJP: 'セントルシア',
    textKR: '세인트루시아',
  },
  {
    code: 'PM',
    textEN: 'Saint Pierre and Miquelon',
    textTC: '聖皮埃與密克隆群',
    textSC: '圣皮埃尔和密克隆群岛',
    textJP: 'サンピエール・ミクロン',
    textKR: '생피에르 미클롱',
  },
  {
    code: 'VC',
    textEN: 'Saint Vincent And The Grenadines',
    textTC: '聖文森特和格林納丁斯',
    textSC: '圣文森特和格林纳丁斯',
    textJP: 'セントビンセントおよびグレナディーン諸島',
    textKR: '세인트빈센트 그레나딘',
  },
  {
    code: 'WS',
    textEN: 'Samoa',
    textTC: '薩摩亞',
    textSC: '萨摩亚',
    textJP: 'サモア',
    textKR: '사모아',
  },
  {
    code: 'SM',
    textEN: 'San Marino',
    textTC: '聖馬力諾',
    textSC: '圣马力诺',
    textJP: 'サンマリノ',
    textKR: '산마리노',
  },
  {
    code: 'ST',
    textEN: 'Sao Tome and Principe',
    textTC: '聖多美和普林西比',
    textSC: '圣多美和普林西比',
    textJP: 'サントメプリンシペ',
    textKR: '상투메 프린시페',
  },
  {
    code: 'SA',
    textEN: 'Saudi Arabia',
    textTC: '沙特阿拉伯',
    textSC: '沙特阿拉伯',
    textJP: 'サウジアラビア',
    textKR: '사우디아라비아',
  },
  {
    code: 'SN',
    textEN: 'Senegal',
    textTC: '塞内加爾',
    textSC: '塞内加尔',
    textJP: 'セネガル',
    textKR: '세네갈',
  },
  {
    code: 'RS',
    textEN: 'Serbia',
    textTC: '塞爾維亞',
    textSC: '塞尔维亚',
    textJP: 'セルビア',
    textKR: '세르비아',
  },
  {
    code: 'SC',
    textEN: 'Seychelles',
    textTC: '塞舌爾',
    textSC: '塞舌尔',
    textJP: 'セーシェル',
    textKR: '세이셸',
  },
  {
    code: 'SL',
    textEN: 'Sierra Leone',
    textTC: '塞拉利昂',
    textSC: '塞拉利昂',
    textJP: 'シエラレオネ',
    textKR: '시에라리온',
  },
  {
    code: 'SG',
    textEN: 'Singapore',
    textTC: '新加坡',
    textSC: '新加坡',
    textJP: 'シンガポール',
    textKR: '싱가포르',
  },
  {
    code: 'SX',
    textEN: 'Sint Maarten (Dutch part)',
    textTC: '聖馬丁',
    textSC: '圣马丁',
    textJP: 'シントマールテン（オランダ領）',
    textKR: '신트마르턴 (네덜란드령)',
  },
  {
    code: 'SK',
    textEN: 'Slovakia',
    textTC: '斯洛伐克',
    textSC: '斯洛伐克',
    textJP: 'スロバキア',
    textKR: '슬로바키아',
  },
  {
    code: 'SI',
    textEN: 'Slovenia',
    textTC: '斯洛文尼亞',
    textSC: '斯洛文尼亚',
    textJP: 'スロベニア',
    textKR: '슬로베니아',
  },
  {
    code: 'SB',
    textEN: 'Solomon Islands',
    textTC: '所羅門群島',
    textSC: '所罗门群岛',
    textJP: 'ソロモン諸島',
    textKR: '솔로몬 제도',
  },
  {
    code: 'SO',
    textEN: 'Somalia',
    textTC: '索馬里',
    textSC: '索马里',
    textJP: 'ソマリア',
    textKR: '소말리아',
  },
  {
    code: 'ZA',
    textEN: 'South Africa',
    textTC: '南非',
    textSC: '南非',
    textJP: '南アフリカ',
    textKR: '남아프리카공화국',
  },
  {
    code: 'GS',
    textEN: 'South Georgia',
    textTC: '南喬治亞島和南桑威奇群島',
    textSC: '南乔治亚岛和南桑威奇群岛',
    textJP: 'サウスジョージア・サウスサンドウィッチ諸島',
    textKR: '사우스조지아 및 사우스샌드위치 제도',
  },
  {
    code: 'KR',
    textEN: 'South Korea',
    textTC: '大韓民國（南韓）',
    textSC: '大韩民国（南韩）',
    textJP: '韓国',
    textKR: '대한민국',
  },
  {
    code: 'SS',
    textEN: 'South Sudan',
    textTC: '南蘇丹',
    textSC: '南苏丹',
    textJP: '南スーダン',
    textKR: '남수단',
  },
  {
    code: 'ES',
    textEN: 'Spain',
    textTC: '西班牙',
    textSC: '西班牙',
    textJP: 'スペイン',
    textKR: '스페인',
  },
  {
    code: 'LK',
    textEN: 'Sri Lanka',
    textTC: '斯里蘭卡',
    textSC: '斯里兰卡',
    textJP: 'スリランカ',
    textKR: '스리랑카',
  },
  {
    code: 'SD',
    textEN: 'Sudan',
    textTC: '蘇丹',
    textSC: '苏丹',
    textJP: 'スーダン',
    textKR: '수단',
  },
  {
    code: 'SR',
    textEN: 'Suriname',
    textTC: '蘇里南',
    textSC: '苏里南',
    textJP: 'スリナム',
    textKR: '수리남',
  },
  {
    code: 'SJ',
    textEN: 'Svalbard And Jan Mayen Islands',
    textTC: '斯瓦巴和揚馬延島',
    textSC: '斯瓦巴和扬马延岛',
    textJP: 'スバールバル諸島・ヤンマイエン島',
    textKR: '스발바르 얀마옌',
  },
  {
    code: 'SZ',
    textEN: 'Swaziland',
    textTC: '斯威士蘭',
    textSC: '斯威士兰',
    textJP: 'スワジランド',
    textKR: '스와질란드',
  },
  {
    code: 'SE',
    textEN: 'Sweden',
    textTC: '瑞典',
    textSC: '瑞典',
    textJP: 'スウェーデン',
    textKR: '스웨덴',
  },
  {
    code: 'CH',
    textEN: 'Switzerland',
    textTC: '瑞士',
    textSC: '瑞士',
    textJP: 'スイス',
    textKR: '스위스',
  },
  {
    code: 'SY',
    textEN: 'Syria',
    textTC: '敘利亞',
    textSC: '叙利亚',
    textJP: 'シリア',
    textKR: '시리아',
  },
  {
    code: 'TW',
    textEN: 'Taiwan',
    textTC: '中國台灣',
    textSC: '中国台湾',
    textJP: '台湾',
    textKR: '대만',
  },
  {
    code: 'TJ',
    textEN: 'Tajikistan',
    textTC: '塔吉克斯坦',
    textSC: '塔吉克斯坦',
    textJP: 'タジキスタン',
    textKR: '타지키스탄',
  },
  {
    code: 'TZ',
    textEN: 'Tanzania',
    textTC: '坦桑尼亞',
    textSC: '坦桑尼亚',
    textJP: 'タンザニア',
    textKR: '탄자니아',
  },
  {
    code: 'TH',
    textEN: 'Thailand',
    textTC: '泰國',
    textSC: '泰国',
    textJP: 'タイ',
    textKR: '태국',
  },
  {
    code: 'BS',
    textEN: 'The Bahamas',
    textTC: '巴哈馬',
    textSC: '巴哈马',
    textJP: 'バハマ',
    textKR: '바하마',
  },
  {
    code: 'GM',
    textEN: 'The Gambia',
    textTC: '岡比亞',
    textSC: '冈比亚',
    textJP: 'ガンビア',
    textKR: '감비아',
  },
  {
    code: 'TG',
    textEN: 'Togo',
    textTC: '多哥',
    textSC: '多哥',
    textJP: 'トーゴ',
    textKR: '토고',
  },
  {
    code: 'TK',
    textEN: 'Tokelau',
    textTC: '托克勞',
    textSC: '托克劳',
    textJP: 'トケラウ',
    textKR: '토켈라우',
  },
  {
    code: 'TO',
    textEN: 'Tonga',
    textTC: '湯加',
    textSC: '汤加',
    textJP: 'トンガ',
    textKR: '통가',
  },
  {
    code: 'TT',
    textEN: 'Trinidad And Tobago',
    textTC: '特立尼達和多巴哥',
    textSC: '特立尼达和多巴哥',
    textJP: 'トリニダード・トバゴ',
    textKR: '트리니다드 토바고',
  },
  {
    code: 'TN',
    textEN: 'Tunisia',
    textTC: '突尼斯',
    textSC: '突尼斯',
    textJP: 'チュニジア',
    textKR: '튀니지',
  },
  {
    code: 'TR',
    textEN: 'Turkey',
    textTC: '土耳其',
    textSC: '土耳其',
    textJP: 'トルコ',
    textKR: '터키',
  },
  {
    code: 'TM',
    textEN: 'Turkmenistan',
    textTC: '土庫曼斯坦',
    textSC: '土库曼斯坦',
    textJP: 'トルクメニスタン',
    textKR: '투르크메니스탄',
  },
  {
    code: 'TC',
    textEN: 'Turks And Caicos Islands',
    textTC: '特克斯和凱科斯群島',
    textSC: '特克斯和凯科斯群岛',
    textJP: 'タークス・カイコス諸島',
    textKR: '터크스 케이커스 제도',
  },
  {
    code: 'TV',
    textEN: 'Tuvalu',
    textTC: '圖瓦盧',
    textSC: '图瓦卢',
    textJP: 'ツバル',
    textKR: '투발루',
  },
  {
    code: 'UG',
    textEN: 'Uganda',
    textTC: '烏干達',
    textSC: '乌干达',
    textJP: 'ウガンダ',
    textKR: '우간다',
  },
  {
    code: 'UA',
    textEN: 'Ukraine',
    textTC: '烏克蘭',
    textSC: '乌克兰',
    textJP: 'ウクライナ',
    textKR: '우크라이나',
  },
  {
    code: 'AE',
    textEN: 'United Arab Emirates',
    textTC: '阿拉伯聯合酋长國',
    textSC: '阿拉伯联合酋长国',
    textJP: 'アラブ首長国連邦',
    textKR: '아랍에미리트',
  },
  {
    code: 'GB',
    textEN: 'United Kingdom',
    textTC: '英國',
    textSC: '英国',
    textJP: 'イギリス',
    textKR: '영국',
  },
  {
    code: 'US',
    textEN: 'United States',
    textTC: '美利堅合眾國',
    textSC: '美利坚合众国',
    textJP: 'アメリカ合衆国',
    textKR: '미국',
  },
  {
    code: 'UM',
    textEN: 'United States Minor Outlying Islands',
    textTC: '美國本土外小島嶼',
    textSC: '美国本土外小岛屿',
    textJP: '合衆国領有小離島',
    textKR: '미국령 군소 제도',
  },
  {
    code: 'UY',
    textEN: 'Uruguay',
    textTC: '烏拉圭',
    textSC: '乌拉圭',
    textJP: 'ウルグアイ',
    textKR: '우루과이',
  },
  {
    code: 'UZ',
    textEN: 'Uzbekistan',
    textTC: '烏茲別克斯坦',
    textSC: '乌兹别克斯坦',
    textJP: 'ウズベキスタン',
    textKR: '우즈베키스탄',
  },
  {
    code: 'VU',
    textEN: 'Vanuatu',
    textTC: '瓦努阿圖',
    textSC: '瓦努阿图',
    textJP: 'バヌアツ',
    textKR: '바누아투',
  },
  {
    code: 'VA',
    textEN: 'Vatican City State (Holy See)',
    textTC: '梵蒂岡',
    textSC: '梵蒂冈',
    textJP: 'バチカン市国',
    textKR: '바티칸 시국',
  },
  {
    code: 'VE',
    textEN: 'Venezuela',
    textTC: '委內瑞拉',
    textSC: '委内瑞拉',
    textJP: 'ベネズエラ',
    textKR: '베네수엘라',
  },
  {
    code: 'VN',
    textEN: 'Vietnam',
    textTC: '越南',
    textSC: '越南',
    textJP: 'ベトナム',
    textKR: '베트남',
  },
  {
    code: 'VG',
    textEN: 'Virgin Islands (British)',
    textTC: '英屬維爾京群島',
    textSC: '英属维尔京群岛',
    textJP: '米領ヴァージン諸島',
    textKR: '미국령 버진아일랜드',
  },
  {
    code: 'VI',
    textEN: 'Virgin Islands (US)',
    textTC: '美國維爾京群島',
    textSC: '美国维尔京群岛',
    textJP: '英領ヴァージン諸島',
    textKR: '영국령 버진아일랜드',
  },
  {
    code: 'WF',
    textEN: 'Wallis And Futuna Islands',
    textTC: '瓦利斯群島和富圖納群島',
    textSC: '瓦利斯群岛和富图纳群岛',
    textJP: 'ウォリス・フツナ',
    textKR: '왈리스 퓌투나',
  },
  {
    code: 'EH',
    textEN: 'Western Sahara',
    textTC: '西撒哈拉',
    textSC: '西撒哈拉',
    textJP: '西サハラ',
    textKR: '서사하라',
  },
  {
    code: 'YE',
    textEN: 'Yemen',
    textTC: '也門',
    textSC: '也门',
    textJP: 'イエメン',
    textKR: '예멘',
  },
  {
    code: 'ZM',
    textEN: 'Zambia',
    textTC: '贊比亞',
    textSC: '赞比亚',
    textJP: 'ザンビア',
    textKR: '잠비아',
  },
  {
    code: 'ZW',
    textEN: 'Zimbabwe',
    textTC: '津巴布韋',
    textSC: '津巴布韦',
    textJP: 'ジンバブエ',
    textKR: '짐바브웨',
  },
];

export const codeListMapping = (originalList: any) => {
  const languageCode = getUpperCaseLanguageCode();
  const list = [
    {
      code: '',
      textEN: 'Select',
      textTC: '選擇',
      textSC: '选择',
      textJP: '選択してください',
      textKR: '선택해주세요',
    },
    ...originalList,
  ].map((itemCode: any) => {
    return {
      id: itemCode.code,
      key: itemCode.code,
      value: itemCode.code,
      text: itemCode[`text${languageCode}`],
    };
  });

  return list;
};

const getUpperCaseLanguageCode = () => {
  const mapping = {
    en: 'EN',
    hk: 'TC',
    cn: 'SC',
    jp: 'JP',
    kr: 'KR',
  };
  const language =
    window.location.pathname
      .split('/')
      .find((item) => ['en', 'hk', 'cn', 'jp', 'kr'].includes(item)) || 'en';

  const languageCode = mapping[language as keyof typeof mapping] || mapping.en;
  return languageCode;
};

export const deviceTypes = [
  'gsr',
  'prearrival',
  'remote',
  'esign',
  'admin',
  'she',
  'ldapauth',
  'paymentRedirect',
] as const;
export type DeviceTypes = (typeof deviceTypes)[number];

export const DEFAULT_FORM_INPUT_CONFIG = {
  registration: {
    fields: [
      {
        name: 'firstName',
        type: 'text',
      },
      {
        name: 'lastName',
        type: 'text',
      },
      {
        name: 'email',
        isRequired: true,
      },
      {
        name: 'tel',
        isRequired: true,
        type: 'phone',
        defaultDistrict: 'HK',
      },
      {
        name: 'address1',
        isRequired: true,
        type: 'textarea',
      },
      {
        name: 'address2',
        type: 'textarea',
      },
      {
        name: 'zipCode',
      },
      {
        name: 'country',
        type: 'select',
        isRequired: true,
      },
      {
        name: 'arrivalHrs',
        type: 'select',
        isRequired: true,
      },
    ],
  },
};

export const DEFAULT_FORM_SELECT_OPTIONS = {
  registration: {
    country: codeListMapping(countryCodeList),
    arrivalHrs: [
      { value: '', id: 'reg.pleaseSelect', key: 'reg.arrival.hr' },
      { value: 12, key: '12:00' },
      { value: 13, key: '13:00' },
      { value: 14, key: '14:00' },
      { value: 15, key: '15:00' },
      { value: 16, key: '16:00' },
      { value: 17, key: '17:00' },
      { value: 18, key: '18:00' },
      { value: 19, key: '19:00' },
      { value: 20, key: '20:00' },
      { value: 21, key: '21:00' },
      { value: 22, key: '22:00' },
      { value: 23, key: '23:00' },
      { value: '00', key: '00:01' },
    ],
    evoucher: [
      { key: 'yes/no', value: undefined, id: 'reg.pleaseSelect' },
      { key: 'yes', value: 'true', id: 'reg.evoucher.yes' },
      { key: 'no', value: 'false', id: 'reg.evoucher.no' },
    ],
  },
};

export const DEFAULT_ROUTE_CONFIG = [
  {
    order: 1,
    route: 'booking-review',
  },
  {
    order: 2,
    route: 'registration',
  },
  {
    order: 3,
    route: 'checkinpayment',
  },
  {
    order: 4,
    route: 'confirm',
  },
];

export enum BOOKING_STATUS {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
}

export const HOTEL_ID = {
  PLAZA: '633e5647d02dd2bf990ed96c',
  EAST: '6641bd847063233124b3d922',
  AMARA: '6650435d676c9dec6a65dd14',
};
